const trackEvent = (name, detail = {}) => {
  if (typeof window === 'undefined') return

  try {
    window.dispatchEvent(new CustomEvent(`leanit101:${name}`, { detail }))
  } catch (error) {
    // Ignore custom event failures in older browsers.
  }

  if (typeof window.gtag === 'function') {
    window.gtag('event', name, detail)
  }

  if (typeof window.fbq === 'function') {
    window.fbq('trackCustom', name, detail)
  }
}

export default trackEvent
